module.exports = __webpack_public_path__ + "static/media/easa.fe52fd8f.png";